import { useState } from 'react';
import { BiLike, BiDislike } from 'react-icons/bi';
import { FiCheck } from 'react-icons/fi';
import './HelpFeedback.css';

export default function HelpFeedback({ articleId }) {
  const [feedback, setFeedback] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const handleFeedback = (isHelpful) => {
    setFeedback(isHelpful);
    setSubmitted(true);

    // Log feedback (could send to analytics service in production)
    console.log(`Feedback for ${articleId}: ${isHelpful ? 'helpful' : 'not helpful'}`);

    // Reset after 3 seconds
    setTimeout(() => {
      setSubmitted(false);
    }, 3000);
  };

  if (submitted) {
    return (
      <div className="help-feedback help-feedback-submitted">
        <span className="help-feedback-thanks">
          <FiCheck size={18} style={{ marginRight: '6px' }} />
          {feedback ? 'Thanks for your feedback!' : 'Thanks! We\'ll improve this article.'}
        </span>
      </div>
    );
  }

  return (
    <div className="help-feedback">
      <span className="help-feedback-question">Was this article helpful?</span>
      <div className="help-feedback-buttons">
        <button
          type="button"
          className="help-feedback-button help-feedback-yes"
          onClick={() => handleFeedback(true)}
          aria-label="Yes, this was helpful"
        >
          <BiLike size={18} /> Yes
        </button>
        <button
          type="button"
          className="help-feedback-button help-feedback-no"
          onClick={() => handleFeedback(false)}
          aria-label="No, this was not helpful"
        >
          <BiDislike size={18} /> No
        </button>
      </div>
    </div>
  );
}
